import { Component, EventEmitter, inject, Input, input, OnInit, Output } from '@angular/core';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { IFormTypes } from '../../models/form-types';
import { AssessmentService } from '../../services/assessment.service';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { BusinessService } from '../../../core/services/business.service';
import { FeedbackDetails } from '../../data/feedback-details';
import { combineLatest, forkJoin, take } from 'rxjs';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent implements OnInit {


  @Input()model!: InitialAssessmentForm;
  @Input()formTypes!: IFormTypes;
  @Output() formReady = new EventEmitter<FormGroup>();

  showOtherFeedbackQuestion = false;
  showGenericFeedbackQuestion = false;
  showBusinessEnquiryFeedbackQuestion = false;
  selectedFormId: string | undefined = '';
   showAppointAgent = false;
   isVevo = false;
   isVevoEmployee = false;
   firmName = '';

   startProcessOptions = [
    { value: '0', label: 'Immediately' },
    { value: '1', label: 'Within 1 month' },
    { value: '3', label: 'Within 3 months' },
    { value: '6', label: 'Within 6 months' },
    { value: '7', label: '6 months or more' }
   ];


 formBuilder = inject(NonNullableFormBuilder);
  
    feedbackForm = this.formBuilder.group({
      comments:[''],
      appointAgent:[''],
      appointAgentTextQuestion:[''],
      startProcess:[''],
      currentClient: [''],
      clientReferenceNumber: ['']
    })

  constructor(private assessmentService: AssessmentService, private businessService: BusinessService) { } 

  ngOnInit() {

    this.model = this.model || new InitialAssessmentForm();
    this.model.feedback = this.model.feedback || new FeedbackDetails();
    console.log('Initial model feedback:', this.model.feedback);

    this.isVevo = this.assessmentService.isVevo();
    this.isVevoEmployee = this.assessmentService.isVevoEmployee(); 
    this.selectedFormId = this.assessmentService.selectedForm()?.id;
    this.showOtherFeedbackQuestion = this.selectedFormId !== this.formTypes.generic && this.selectedFormId !== this.formTypes.businessEnquiry;
    this.showGenericFeedbackQuestion = this.selectedFormId === this.formTypes.generic;
    this.showBusinessEnquiryFeedbackQuestion = this.selectedFormId === this.formTypes.businessEnquiry;

  
  const feedbackObs$ = this.businessService.getFeedback();
  const businessObs$ = this.businessService.GetInitialAssessmentBusinessDetails();
  
  combineLatest({
    feedback: feedbackObs$,
    businessDetails: businessObs$
  }).pipe(take(1))
    .subscribe({
    next: ({ feedback, businessDetails }) => {
      
      this.showAppointAgent = feedback.showAppointAgentQuestion;
      if(this.model.feedback == null){
        this.model.feedback = new FeedbackDetails();
      }

      this.model.feedback!.appointAgentTextQuestion = feedback.appointAgentQuestion;
      
      this.firmName = businessDetails.name;
      this.initializeForm();
      this.formReady.emit(this.feedbackForm);
    },
    error: (error) => {
      console.error('💥 COMBINE LATEST ERROR:', error);
    },
    complete: () => {
      console.log('✅ COMBINE LATEST COMPLETED');
    }
  });


  } 

  initializeForm(){

    if (this.model.feedback) {
    const formValues = {
      appointAgent: this.model.feedback.appointAgent,
      comments: this.model.feedback.comments,
      appointAgentTextQuestion: this.model.feedback.appointAgentTextQuestion,
      startProcess: this.model.feedback.startProcess,
      currentClient: this.model.feedback.currentClient,
      clientReferenceNumber: this.model.feedback.clientReferenceNumber
    } as any;
    
    this.feedbackForm.patchValue(formValues);

    this.feedbackForm.valueChanges.subscribe(value => {
      if (this.model.feedback && value) {
          Object.assign(this.model.feedback, {
          ...value
        });
      } 

  });
  
  }
}

  
  get commentsQuestionLabel(): string {
    if (this.showOtherFeedbackQuestion) {
      return 'Do you have any questions or additional information you want to provide?';
    } else if (this.showGenericFeedbackQuestion) {
      return 'Please provide details about what your enquiry is about and what type of visas you might be interested in';
    } else if (this.showBusinessEnquiryFeedbackQuestion) {
      return 'Please provide details about what your enquiry is about';
    } else {
      return 'Do you have any questions or additional information you want to provide?';
    }
  }



}
